<template>
  <div>
    <wc-data-box
      :title='toolbarData.title'
      :titleIcon='toolbarData.icon'
      :titleIconColor='toolbarData.iconColor'
      showEdit
      @edit='edit'
    >
      <wc-two-column-table
        :items='data'
        @rowClick='edit'
      ></wc-two-column-table>

    </wc-data-box>

    <wc-dialog
      :showDialog='showDialog'
      :title='toolbarData.title'
      :icon='toolbarData.icon'
      :disableButtons='!isFormValid'
      @cancel='showDialog = false'
      @save='save'
      width='550'
    >
      <v-form v-model='isFormValid' ref='form'>
        <details-form v-model='profileCopy'></details-form>
      </v-form>
    </wc-dialog>

  </div>
</template>

<script>
import _ from 'lodash'
import DetailsForm from '../../components/forms/DetailsForm'

export default {
  name: 'profile-details',
  props: {
    profile: {
      required: true
    }
  },
  data: () => ({
    isLoading: false,
    showDialog: false,
    isFormValid: false,
    profileCopy: {}
  }),
  computed: {
    toolbarData () {
      return this.$store.state.icons.dataBox.details
    },
    data () {
      return [
        { text: 'email', value: this.profile.email },
        { text: 'Home phone', value: this.profile.home_phone },
        { text: 'Cell phone', value: this.profile.cell_phone },
        { text: 'Address', value: this.profile.address },
        { text: 'City', value: this.profile.city },
        { text: 'Country', value: this.profile.country },
        { text: 'Province', value: this.profile.province },
        { text: 'Postal code', value: this.$options.filters.postal(this.profile.postal) }
      ]
    }
  },
  methods: {
    edit () {
      this.profileCopy = _.cloneDeep(this.profile)
      this.showDialog = true
    },
    save () {
      this.$emit('update', this.profileCopy)
      this.showDialog = false
    }
  },
  components: {
    'details-form': DetailsForm
  }
}
</script>
